export default __webpack_public_path__ + "static/media/bolinhas4.57e266a0.svg";